export const buildLinkMailTo = (email: string) => `mailto:${email}`;
export const buildLinkPhoneTo = (phoneNumber: string) => `tel:${phoneNumber}`;
